import { render, staticRenderFns } from "./organizationManagement.vue?vue&type=template&id=050d2eb9&scoped=true&"
import script from "./organizationManagement.vue?vue&type=script&lang=js&"
export * from "./organizationManagement.vue?vue&type=script&lang=js&"
import style0 from "./organizationManagement.vue?vue&type=style&index=0&id=050d2eb9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "050d2eb9",
  null
  
)

export default component.exports